/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Double_Trial_BodyInputs */

const en_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Plus free for a full 14 days. We'll remind you 2 days before it ends, and you can cancel anytime.`)
};

const ar_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرّب Plus مجاناً لمدة 14 يوماً كاملة. سنذكّرك قبل انتهائها بيومين، ويمكنك الإلغاء في أي وقت.`)
};

const de_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste Plus 14 Tage lang kostenlos. Wir erinnern dich 2 Tage vor Ablauf, und du kannst jederzeit kündigen.`)
};

const es_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba Plus gratis durante 14 días completos. Te avisaremos 2 días antes de que termine, y puedes cancelar cuando quieras.`)
};

const fr_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez Plus gratuitement pendant 14 jours complets. Nous vous préviendrons 2 jours avant la fin, et vous pouvez annuler à tout moment.`)
};

const it_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova Plus gratis per 14 giorni completi. Ti avviseremo 2 giorni prima della scadenza e potrai annullare in qualsiasi momento.`)
};

const ja_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus を14日間無料でお試しいただけます。終了2日前にお知らせしますので、いつでもキャンセル可能です。`)
};

const ko_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus를 14일 동안 무료로 체험해 보세요. 종료 2일 전에 알려드리며, 언제든지 취소할 수 있습니다.`)
};

const pt_br_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente o Plus grátis por 14 dias completos. Vamos avisar você 2 dias antes do término, e você pode cancelar quando quiser.`)
};

const ru_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте Plus бесплатно в течение полных 14 дней. Мы напомним вам за 2 дня до окончания, и вы можете отменить в любой момент.`)
};

const th_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ Plus ฟรีเต็ม 14 วัน เราจะแจ้งเตือนคุณล่วงหน้า 2 วันก่อนหมดอายุ และคุณสามารถยกเลิกได้ทุกเมื่อ`)
};

const tr_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'ı 14 gün boyunca ücretsiz deneyin. Süre bitmeden 2 gün önce size hatırlatırız ve istediğiniz zaman iptal edebilirsiniz.`)
};

const zh_cn_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体验 Plus 14 天，到期前 2 天提醒你，随时可取消。`)
};

const zh_tw_double_trial_body = /** @type {(inputs: Double_Trial_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 天免費完整體驗 Plus！到期前 2 天提醒你，隨時可取消。`)
};

/**
* | output |
* | --- |
* | "Try Plus free for a full 14 days. We'll remind you 2 days before it ends, and you can cancel anytime." |
*
* @param {Double_Trial_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const double_trial_body = /** @type {((inputs?: Double_Trial_BodyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Double_Trial_BodyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_double_trial_body(inputs)
	if (locale === "ar") return ar_double_trial_body(inputs)
	if (locale === "de") return de_double_trial_body(inputs)
	if (locale === "es") return es_double_trial_body(inputs)
	if (locale === "fr") return fr_double_trial_body(inputs)
	if (locale === "it") return it_double_trial_body(inputs)
	if (locale === "ja") return ja_double_trial_body(inputs)
	if (locale === "ko") return ko_double_trial_body(inputs)
	if (locale === "pt_br") return pt_br_double_trial_body(inputs)
	if (locale === "ru") return ru_double_trial_body(inputs)
	if (locale === "th") return th_double_trial_body(inputs)
	if (locale === "tr") return tr_double_trial_body(inputs)
	if (locale === "zh_cn") return zh_cn_double_trial_body(inputs)
	return zh_tw_double_trial_body(inputs)
});